import dialogContentClasses from "@mui/material/DialogContent/dialogContentClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiDialogTitleTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "H5")), { padding: `${dt.space.stack.large} ${dt.inline.large} ${dt.space.stack.xLarge3} ${dt.inline.large}`, [`&:has(+ .${dialogContentClasses.root})`]: {
                    paddingBottom: dt.stacked.medium,
                } }),
        },
    };
};
